<template>
<div class="user-report" :style="{'min-height':height+'px'}">
  <ul class="user-report-list">
    <li v-for="item,index in report_list" :key="index">
      <div class="report-img" @click="goDetail(item.uid)">
        <img :src="item.logo_path" />
      </div>
      <div class="report-info">
        <div class="report-title" @click="goDetail(item.uid)">{{item.title}}</div>
        <div class="report-dec">
          <div class="report-span" v-if="item.src_author"><i class="iconfont">&#xe645;</i>{{item.src_author}}</div>
          <div class="report-span"><i class="iconfont">&#xe632;</i>{{item.publish_time | timeTrans}}</div>
          <div class="report-span"><i class="iconfont">&#xe645;</i>{{item.category_id | dealName(meta.report_type)}}</div>
          <div class="report-span"><i class="iconfont">&#xe621;</i>￥{{item.price}}</div>
        </div>
        <a @click="goDetail(item.uid)" class="btn">阅读</a>
      </div>
    </li>
  </ul>
  <div class="page clear" v-if="total > 10">
    <Page
      :total="total"
      :page-size="10"
      class="page_list"
      show-total
      show-elevator
      :current="params.page"
      @on-change="changePage"
    />
  </div>
  <Nothing v-if="total == 0">
    <p>暂无购买的报告</p>
  </Nothing>
</div>
</template>
<script>
import Nothing from '@/components/Nothing2'
import {paidReport} from '../../../service'
export default {
  components: {Nothing},
  props: ['meta'],
  data() {
    return {
      report_list: [],
      total: 0,
      height: 0,
      params: {
        page: 1
      }
    }
  },
  computed: {
    user_key() {
      return this.$store.state.user_key
    }
  },
  methods: {
    async paidReport() {
      let res = await paidReport({
        user_key: this.$store.state.user_key,
        page: this.params.page
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'report_list', res.res)
        this.$set(this.$data, 'total', res.count)
        this.$emit('reportTotal', res.count)
      } else {
        this.$Message.error(res.message)
      }
    },
    changePage(page) {
      this.params.page = page
      this.paidReport()
    },
    goDetail(uid) {
      // this.$router.push({name: 'ReportDetail', params: {uid: uid}})
      const { href } = this.$router.resolve({
        name: "ReportDetail",
        params: {
          uid: uid
        }
      })
      window.open(href, '_blank')
    },
  },
  created() {
    this.paidReport()
  },
  mounted() {
    this.height = document.documentElement.clientHeight - 202
    // window.onresize =  () => {
    //   this.height = document.documentElement.clientHeight - 242
    // }
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/report.stylus'
</style>
